export default {
  BUReceiveBudgetPlanList: {
    Title: 'Nhận dự toán',
  },
  BUReceiveBudgetPlanDetail: {
    Title: 'Nhận dự toán',
    Text: {
      Description: 'Diễn giải',
      Allotment: 'Phân bổ',
      NoAllotment: 'Không phân bổ',
      Quarterly: 'Theo quý',
      Monthly: 'Theo tháng',
      RefDate: 'Ngày CT',
      RefNo: 'Số CT',
      PostedDate: 'Ngày HT',
      BeginTheYear: 'Đầu năm',
      Additional: 'Bổ sung',
      DecisionDay: 'Ngày QĐ',
      DecisionNumber: 'Số QĐ',
      Guide: 'Hướng dẫn',
      Year: 'Năm',
    },
    TextTooltip: {
      RefDate: 'Ngày chứng từ',
      RefNo: 'Số chứng từ',
      PostedDate: 'Ngày hạch toán',
      DecisionNumber: 'Số quyết định',
      DecisionDay: 'Ngày quyết định',
    },
  },
};
